enum TenantLevelEnum {
  tenantless = 0,
  tenant = 1,
  subTenant = 2
}

export default TenantLevelEnum;
